Vue.component('admin-subtest-attempt', {
  props: ['subtestAttemptId'],

  data () {
    return {
      subtestAttempt: null,
      moduleType: null,
    };
  },

  /**
   * The component has been created by Vue.
   */
  created () {
    let self = this;

    this.getSubtestAttempt(this.subtestAttemptId);

    this.$on('getSubtestAttempt', function (id) {
      this.getSubtestAttempt(id);
    });

    this.$on('showGradeSubtestAttemptModal', function () {
      $('#modal-grade-subtest-attempt').modal('show');
    });

    this.$on('showFeedbackSubtestAttemptModal', function () {
      $('#modal-feedback-subtest-attempt').modal('show');
    });

    this.$on('showAssignSubtestAttemptModal', function () {
      $('#modal-assign-subtest-attempt').modal('show');
    });

    this.$on('showUpdateSubtestAttemptSpeakingStatusModal', function () {
      $('#modal-update-subtest-attempt-speaking-status').modal('show');
    });

    this.$on('showUpdateSubtestAttemptPlatformModal', function () {
      $('#modal-update-subtest-attempt-platform').modal('show');
    });

    this.$on('showCancelSubtestAttemptModal', function (moduleType) {
      self.moduleType = moduleType;
      $('#modal-cancel-subtest-attempt').modal('show');
    });
  },

  methods: {
    /**
     * Get the specified SubtestAttempt.
     */
    getSubtestAttempt (id) {
      axios.get('/api/subtest-attempts/' + id)
        .then(response => {
          this.subtestAttempt = response.data.subtestAttempt;
        });
    },
  }
});
